var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRednote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arcticons:xiaohongshu-rednote",
    clipPath: "url(#clip0_143_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0625 0.4375H2.9375C1.55679 0.4375 0.4375 1.55679 0.4375 2.9375V21.0625C0.4375 22.4432 1.55679 23.5625 2.9375 23.5625H21.0625C22.4432 23.5625 23.5625 22.4432 23.5625 21.0625V2.9375C23.5625 1.55679 22.4432 0.4375 21.0625 0.4375Z",
    fill: "#007D1F",
    stroke: "#007D1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.159 9.1084V14.8909M13.5459 10.0309V14.8909M12.594 10.0309H14.4984M11.9746 14.8909H14.9765M15.9759 10.0309H18.5571C18.8634 10.0309 19.1102 10.2784 19.1102 10.584V12.269",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6344 12.2684H20.1306C20.2119 12.2684 20.2924 12.2844 20.3676 12.3156C20.4427 12.3467 20.5109 12.3923 20.5684 12.4498C20.6258 12.5074 20.6714 12.5757 20.7025 12.6508C20.7335 12.7259 20.7495 12.8065 20.7494 12.8878V14.2715C20.7494 14.4356 20.6842 14.593 20.5681 14.709C20.4521 14.8251 20.2947 14.8903 20.1306 14.8903H18.9869M20.1487 10.3228L20.75 9.76652M10.5525 14.8909H9.22875M7.7425 10.7315L8.17813 13.9003M3.67687 10.7315L3.25 14.0621M5.70125 9.1084V14.0409C5.70125 14.5096 5.32063 14.8909 4.85125 14.8909H4.625M10.5525 9.1084L9.69812 11.1415H10.8644L10.01 13.174H11.1756",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_1038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRednote);
export default __webpack_public_path__ + "static/media/rednote.21f98cb7f8d98e456abca378ba213b85.svg";
export { ForwardRef as ReactComponent };